const SHOW_ERROR = 'AFTERPAY_SHOW_ERROR';
const RESET_ERROR = 'AFTERPAY_RESET_ERROR';
const TOGGLE_SELECTED = 'AFTERPAY_TOGGLE_SELECTED';
const SET_READY = 'AFTERPAY_SET_READY';
const SET_WIDGET_DATA = 'AFTERPAY_SET_WIDGET_DATA';
const SET_WIDGET_LOADING = 'AFTERPAY_SET_WIDGET_LOADING';
const SET_WIDGET_ERROR = 'AFTERPAY_SET_WIDGET_ERROR';

export {
    SHOW_ERROR, RESET_ERROR, TOGGLE_SELECTED, SET_READY, SET_WIDGET_DATA, SET_WIDGET_LOADING, SET_WIDGET_ERROR
};
